/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import ApiService from 'cio/services/api';
import { task } from 'ember-concurrency';
import AccountService from 'cio/services/account';
import AnalyticsService from 'cio/services/analytics';

interface GatedFeaturesCtaArgs {
  featureName?: string;
}

export default class GatedFeaturesCta extends Component<GatedFeaturesCtaArgs> {
  @tracked hasBeenClosedByUser = false;
  @service account!: AccountService;
  @service api!: ApiService;
  @service analytics!: AnalyticsService;

  get featureName() {
    return this.args.featureName ?? '';
  }

  sendEvent = task({ keepLatest: true }, async () => {
    let currentAccount = this.account.current;
    let { currentUser } = currentAccount;

    this.analytics.track('plan_billing', 'switch_to_premium_button_clicked', {
      data: {
        account_id: currentAccount.id,
        feature_name: this.featureName,
        requester: currentUser.fullName,
        requester_email: currentUser.email,
        requester_user_id: currentUser.id,
      },
    });

    let response = await this.api.post('track', {
      pathScope: 'account',
      data: {
        name: 'gated_feature_interaction',
        type: 'user',
        // TODO: "object" seems to be required, but unclear what the value should be.
        // "user" seems fine for now, but should probably update soon
        object: 'user',
        data: {
          account_id: currentAccount.id,
          feature_name: this.featureName,
          requester: currentUser.fullName,
          requester_email: currentUser.email,
          requester_user_id: currentUser.id,
          interaction_type: 'upgrade',
          // TODO: Investigate whether we need additional_info at all
          additional_info: '',
        },
      },
    });

    // If response === null, the request was successful
    if (response !== null) {
      throw new Error();
    }
  });

  @action
  trigger() {
    this.hasBeenClosedByUser = false;
    this.sendEvent
      .perform()
      // Empty catch to prevent error from being sent
      // to Sentry. Might handle it properly later on
      .catch(() => {});
  }

  @action
  handleClose() {
    this.hasBeenClosedByUser = true;
  }

  get hasSentEvent() {
    return this.sendEvent.performCount > 0;
  }

  get hasSentSuccessfulEvent() {
    return this.sendEvent.lastSuccessful != null;
  }

  get hasError() {
    return this.sendEvent.last?.isError ?? false;
  }
}
